@if (hasSymbol() || isLoadingPriceTarget()) {
	<div class="tech-analysis">
		<div
			#techAnalysis
			class="tech-analysis-widget"
		></div>
		@if (isLoadingPriceTarget()) {
			<ng-container *ngTemplateOutlet="skeletonPriceTarget" />
		}
	</div>
}

<ng-template #skeletonPriceTarget>
	<div class="skeleton-price-target">
		<div class="timeframes">
			@for (item of [].constructor(5); track item) {
				<div
					class="item"
					[tuiSkeleton]="true"
				></div>
			}
		</div>
		<div class="figure-wrapper">
			<div
				class="figure"
				[tuiSkeleton]="true"
			></div>
		</div>
		<div class="numbers">
			@for (item of [].constructor(3); track item) {
				<div
					class="item"
					[tuiSkeleton]="true"
				></div>
			}
		</div>
	</div>
</ng-template>
